import React from "react";
import { useContext } from "react";
import { SelectedPatientContext } from "../SelectedPatientContext.tsx";
import { Line } from "react-chartjs-2";
import {Spinner, Switch} from "@fluentui/react-components";
import { webLightTheme } from '@fluentui/react-components';
import ChartStreaming from "@robloche/chartjs-plugin-streaming";
import dayjs from "dayjs";
import "chartjs-adapter-dayjs-4/dist/chartjs-adapter-dayjs-4.esm.js";
import { API_PATH } from "../Constants.ts";
import { Chart as ChartJS, LineElement, LinearScale, PointElement} from 'chart.js';
ChartJS.register(ChartStreaming, LineElement, PointElement, LinearScale)

export const HeartBeatChart = () => {
    const [isConnected, setIsConnected] = React.useState(false);
    let heartbeat = null;
    let lastHeartBeatId = 0;
    let first = true;
    const { selectedPatientId} = useContext(SelectedPatientContext);

    const [heartrateChartEnabled, setHeartrateChartEnabled] = React.useState(false);
    React.useEffect(() => {
        const timer = setInterval(() => {
            if (selectedPatientId===null || !heartrateChartEnabled) return;

            fetch(API_PATH.LOGS + `?limit=1&order[id]=desc&query=(tag=='VR'ANDtitle=='Heartbeat'ANDinserted_by_user_id==${encodeURIComponent(selectedPatientId)})&${Math.random()}`).then(
                result => {
                    return result.json();
                }).then(data => {
                    heartbeat = data[0];
                });
        }, 1000);
        return () => clearInterval(timer);
    });

    ChartJS.defaults.defaultFontFamily = "'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serifFont family fontFamilyBase";
    ChartJS.defaults.defaultFontColor = webLightTheme.colorNeutralForeground1;
    const data = {
        datasets: [
            {
                label: "Heart rate [bpm - beats per minute]",
                borderColor: "red",
                fill: false,
                lineTension: 0.25,
                borderWidth: 1,
                pointStyle: 'circle',
                data: []
            }
        ]
    };
    const options = {
        plugins: {
            legend: {
                display: false
            },
            streaming: {
                frameRate: 15
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        elements: {
            line: {
                tension: 0.5
            }
        },
        scales: {
            x: {
                    type: "realtime",
                    realtime: {
                        onRefresh: function (chart) {
                            if (heartbeat == null)
                                return;
                            if (lastHeartBeatId !== heartbeat.id) {
                                lastHeartBeatId = heartbeat.id;
                                if (!first) {
                                    chart.data.datasets[0].data.push({
                                        x: dayjs().toDate(),
                                        y: parseFloat(heartbeat.message)
                                    });
                                    setIsConnected(true);
                                }
                                first = false;
                            }
                        },
                        delay: 1000,
                        duration: 120000
                    },
                    ticks: {
                        callback: function (value) {
                            return dayjs(value).format("HH:mm:ss");

                        }
                    }
                },
            y: {
                    ticks: {
                        callback: function (value, index, values) {
                            return value + ' bpm';
                        }
                    }
                }
        }
    };

    return (
        <>
            <Switch
                checked={heartrateChartEnabled}
                onChange={(_, data) => setHeartrateChartEnabled(Boolean(data?.checked))}
                label="Auto-update chart"
            />
            {!isConnected && <div style={{ position: 'absolute', left: '0', right: '0', top: '0', bottom: '0', display: 'flex', justifyContent: 'center', alignItems: 'center', pointerEvents: 'none' }}>
                <Spinner size="small" label="Data not available..." style={{ background: webLightTheme.colorNeutralBackground1, padding: '10px' }} />
            </div>}
            <Line data={data} options={options} />
        </>
    );
};
